import { forwardRef } from 'react';

import { baseClasses, containerClasses, sizeClasses } from 'components/cart/NewCartItem/ProductCardPrice.classes';
import type { ProductCardPriceProps } from 'components/cart/NewCartItem/ProductCardPrice.types';
import { getTestId } from 'utils/testing';
import { cn } from 'helpers/classnames';
import { removeTrailingZeroes } from 'helpers/ProductUtils';

export const ProductCardPrice = forwardRef<HTMLElement, ProductCardPriceProps>((props: ProductCardPriceProps, ref) => {
  const { className, price, msrp, size = 'small', children, testId, ...forwardProps } = props;
  const isOnSale = parseFloat(String(price)) < parseFloat(String(msrp));
  const isOnSaleClasses = isOnSale ? 'zappos:text-red-350 text-[#ae4343]' : ''; // 6pm support

  return (
    <dd className={cn(containerClasses, className)} data-test-id={getTestId(testId)} ref={ref} {...forwardProps}>
      <span
        className={cn(baseClasses, isOnSaleClasses, sizeClasses[size])}
        data-test-id={getTestId(testId, 'price')}
      >{`$${removeTrailingZeroes(Number(price).toFixed(2))}`}</span>
      {isOnSale && (
        <span
          className="body-xs text-gray-600 line-through"
          data-test-id={getTestId(testId, 'msrp')}
        >{`$${removeTrailingZeroes(Number(msrp).toFixed(2))}`}</span>
      )}
      {children}
    </dd>
  );
});

ProductCardPrice.displayName = 'ProductCardPrice';
